import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/images/premium-pill.png'
import _imports_1 from '../../../assets/images/chat/search-icon.svg'
import _imports_2 from '../../../assets/images/chat/filter-bar.svg'
import _imports_3 from '../../../assets/images/chat/edit-icon.svg'
import _imports_4 from '../../../assets/images/chat/eye-open.svg'
import _imports_5 from '../../../assets/images/chat/draft.svg'
import _imports_6 from '../../../assets/images/chat/muted-bell.svg'


const _hoisted_1 = { class: "nav list-group list-group-flush message-navigation" }
const _hoisted_2 = { class: "d-flex align-items-center h-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold mb-0 ms-2 text-app-secondary" }, "Chat", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ms-2 mt-1 premium-pill-img",
    src: _imports_0
  })
], -1 /* HOISTED */)
const _hoisted_5 = { class: "ms-auto" }
const _hoisted_6 = { class: "inline-block ms-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn font-size-xs px-1 py-0 text-primary",
  "data-bs-toggle": "dropdown",
  id: "conversation-nav-ellipsis"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h font-size-lg" })
], -1 /* HOISTED */)
const _hoisted_8 = {
  class: "dropdown-menu py-1",
  "aria-labelledby": "conversation-nav-ellipsis"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "eye-open-icon"
}, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Mark All as Read ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "nav-item list-group-item message-list-item"
}
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "input-group-append" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times dialog-close text-secondary font-size-sm" }, null, -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "nav-item list-group-item message-list-item active new-chat-li"
}
const _hoisted_18 = { class: "d-flex align-items-center mt-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ava-initials me-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-comment-dots" })
], -1 /* HOISTED */)
const _hoisted_20 = { class: "ms-2 flex-grow-1" }
const _hoisted_21 = { class: "d-flex align-items-start" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "me-auto mb-1 flex-grow-1" }, " New Chat ", -1 /* HOISTED */)
const _hoisted_23 = { class: "conversation-list" }
const _hoisted_24 = ["id", "onClick"]
const _hoisted_25 = { class: "d-flex align-items-center min-width-0" }
const _hoisted_26 = { class: "ps-2 flex-grow-1 min-width-0" }
const _hoisted_27 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = {
  key: 0,
  class: "text-dark"
}
const _hoisted_33 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_34 = {
  key: 0,
  class: "fst-italic text-truncate me-2"
}
const _hoisted_35 = {
  key: 2,
  class: "d-flex align-items-center"
}
const _hoisted_36 = {
  key: 0,
  class: "text-danger me-2"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation" }, null, -1 /* HOISTED */)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  class: "text-danger fw-bold pe-1 font-size-md"
}
const _hoisted_40 = {
  key: 2,
  class: "text-danger font-weight-bold font-size-md"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"1rem"},
  src: _imports_5
}, null, -1 /* HOISTED */)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 4 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"1rem"},
  src: _imports_6
}, null, -1 /* HOISTED */)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "py-1" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "loader-parent" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "msg-loader" })
], -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 0,
  class: "nav-item pe-none list-group-item text-dark h-100 d-flex justify-content-center text-center flex-column"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h5", null, "New Conversations will live here", -1 /* HOISTED */)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, "Select the New Chat icon to start a new conversation.", -1 /* HOISTED */)
const _hoisted_53 = { class: "h-100 overflow-auto" }
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"ava-initials me-1\"><span></span></div><div class=\"ms-2 flex-grow-1\"><span class=\"shimmer-loading w-90 lighten\"></span><div class=\"message-content\"><span class=\"shimmer-loading w-60 lighten\"></span></div></div></div>", 1)
const _hoisted_55 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvaInitials = _resolveComponent("AvaInitials")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item list-group-item message-list-itemm nav-list-header", { active: _ctx.newConversation }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("img", {
              class: "cursor-pointer",
              src: _imports_1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSearchBox(true)))
            }, null, 512 /* NEED_PATCH */), [
              [_directive_tooltip, { title: `Search`, placement: 'left' }]
            ]),
            _withDirectives(_createElementVNode("img", {
              class: "mx-3 cursor-pointer",
              src: _imports_2,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSort(_ctx.sortBy)))
            }, null, 512 /* NEED_PATCH */), [
              [_directive_tooltip, { title: `Sort by ${_ctx.sortText}`, placement: 'left' }]
            ]),
            _withDirectives(_createElementVNode("img", {
              class: "cursor-pointer",
              src: _imports_3,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToNewConversation && _ctx.navigateToNewConversation(...args)))
            }, null, 512 /* NEED_PATCH */), [
              [_directive_tooltip, { title: `New Chat`, placement: 'left' }]
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  class: "dropdown-item font-size-sm",
                  href: "javascript:void(0);",
                  id: "task-manager",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.markAllAsRead && _ctx.markAllAsRead(...args)))
                }, _hoisted_11)
              ])
            ])
          ])
        ])
      ], 2 /* CLASS */),
      (_ctx.openSearch)
        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control border-end-0",
                placeholder: "Search User Name or Conversation Title",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.term) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.term],
                [_directive_focus]
              ]),
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("div", {
                  class: "input-group-text bg-transparent px-2",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSearchBox(false)))
                }, _hoisted_16)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.newConversation)
        ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("i", {
                    class: "fas fa-trash-alt text-danger align-self-center cursor-pointer",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelNewConversation && _ctx.cancelNewConversation(...args)))
                  }, null, 512 /* NEED_PATCH */), [
                    [_directive_tooltip, { title: `Cancel New Chat`, placement: 'left' }]
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("ul", {
        class: _normalizeClass(["nav list-group list-group-flush h-100 overflow-hidden message-navigation", { 'custom-scrollbar': _ctx.userOs == 'Windows' }])
      }, [
        _createCommentVNode(" Added extra div with v-show to make scroll pagination works\r\n            It needs 'scroll-paginate' class when mounted "),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["overflow-auto scroll-paginate h-100", { 'custom-scrollbar': _ctx.userOs == 'Windows' }])
        }, [
          ((!_ctx.isLoading || _ctx.pageNumber > 1) && _ctx.allMessageNavOptions?.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.allMessageNavOptions, (message, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: message.id,
                  id: `conversation-${message.id}`,
                  class: _normalizeClass(["nav-item list-group-item message-list-item", _ctx.selectedConversationClass(index)]),
                  onClick: ($event: any) => (_ctx.handleMenuSelection(message))
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_AvaInitials, {
                      classes: "me-2",
                      initialsType: message?.conversationType,
                      user: _ctx.getUser(message?.loginIds[0]),
                      showStatus: message?.isDraftConversation ? false : true,
                      isDraftConv: message?.isDraftConversation
                    }, null, 8 /* PROPS */, ["initialsType", "user", "showStatus", "isDraftConv"]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["mb-1 text-truncate", {
                                            'fw-bold': message?.unread > 0,
                                            'text-dark': !(message?.unread > 0)
                                        }])
                        }, [
                          (message?.title?.length > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(message.title), 1 /* TEXT */))
                            : (message?.loginIds?.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.formatConversationTitle(message.loginIds)), 1 /* TEXT */))
                              : (message?.isDraftConversation)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "New Chat"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_31, " Just You "))
                        ], 2 /* CLASS */),
                        (!message?.isDraftConversation)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_32, _toDisplayString(_ctx.formatDateToLocalBasedOnDayMode(message.modifiedOn, true)), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        (message?.isDraftConversation || message?.hasDraftMessage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Draft "))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["text-truncate me-2", {
                                            'fw-bold': message?.unread > 0,
                                            'text-dark': !(message?.unread > 0)
                                        }])
                            }, _toDisplayString(_ctx.formatDisplayMessage(_ctx.sanitizeMarkup(_ctx.markdownToHtml(message.text)))), 3 /* TEXT, CLASS */)),
                        (
                                            message?.unread > 0 ||
                                            message.isMuted ||
                                            message?.isDraftConversation ||
                                            message?.hasDraftMessage
                                        )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              (message?.isImportant && message?.unread > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _hoisted_38))
                                : _createCommentVNode("v-if", true),
                              (message?.isCurrentUserTagged && message?.unread > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "@"))
                                : _createCommentVNode("v-if", true),
                              (message?.isDraftConversation || message?.hasDraftMessage)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _hoisted_42))
                                : _createCommentVNode("v-if", true),
                              (message?.unread > 0 && !message.isMuted)
                                ? (_openBlock(), _createElementBlock("b", {
                                    key: 3,
                                    class: _normalizeClass(["unread-count", { 'd-none': !(message?.unread > 0) }])
                                  }, _toDisplayString(message.unread), 3 /* TEXT, CLASS */))
                                : _createCommentVNode("v-if", true),
                              (message.isMuted)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, _hoisted_45))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_24))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _withDirectives(_createElementVNode("li", _hoisted_46, _hoisted_48, 512 /* NEED_PATCH */), [
            [_vShow, _ctx.isLoading && _ctx.pageNumber > 1]
          ])
        ], 2 /* CLASS */), [
          [_vShow, (!_ctx.isLoading || _ctx.pageNumber > 1) && _ctx.allMessageNavOptions?.length > 0]
        ]),
        (!_ctx.isLoading && _ctx.allMessageNavOptions?.length === 0)
          ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
              (_ctx.term)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_50, "No results found"))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_51,
                    _hoisted_52
                  ], 64 /* STABLE_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_53, [
          (_ctx.isLoading && _ctx.pageNumber < 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(8, (i) => {
                return _createElementVNode("li", {
                  key: i,
                  class: "nav-item list-group-item d-flex justify-content-center text-middle flex flex-column"
                }, _hoisted_55)
              }), 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ], 2 /* CLASS */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}